import type { ReactNode } from 'react';
import clsx from 'clsx';
import './SectionTitle.css';

export interface SectionTitleProps {
  children: ReactNode;
  className?: string;
  id?: string;
  as?: 'h2' | 'h3' | 'p';
}

/**
 * Заголовок секции: синий цвет (--title-color), капс и типографика как у
 * .project-details-popover__section-title и заголовков мини-таблиц в таблице.
 */
export function SectionTitle({ children, className, id, as: Tag = 'h3' }: SectionTitleProps) {
  return (
    <Tag id={id} className={clsx('section-title', className)}>
      {children}
    </Tag>
  );
}
